import { configureStore } from "@reduxjs/toolkit";
import MainSlice from "../Slices/index"

const Store=configureStore({
    reducer:{
        MainSlice
    }
})

export default Store